<template>
<div id="removeclass">
   <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal">
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
      >
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group">
              <label>{{ role }}</label>
              <app-input
                type="select"
                id="inputs_supplier"
                :list='supplierList'
                v-model="inputs.supplier_id"
                :disabled="true"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group">
              <label>{{ $t("title") }}</label>
              <app-input type="text" v-model="inputs.title"
              :required="true" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label>{{ $t("description") }}</label>
              <app-input
                type="textarea"
                id="inputs_description"
                v-model="inputs.description"
                :required="true"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="inputs_forms">{{ $t("forms") }}</label>
              <app-input
                type="multi-select"
                :isAnimatedDropdown="true"
                :placeholder="$t('forms')"
                :list="forms"
                v-model="inputs.form_id"
              />
              <p v-if="refreshShow == false" class="font-italic text-muted">
                {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
              </p>
              <p v-if="refreshShow == true" class="font-italic text-muted">
                <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group">
              <label>{{ $t("start_date_&_time") }}</label>
              <app-input
                type="date"
                v-model="inputs.start_date"
                :placeholder="$t('select_valid_date')"
                :required="true"
              />
              <!-- <app-input
                type="time"
                v-model="inputs.start_time"
              /> -->
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group">
              <label>{{ $t("due_date_&_time") }}</label>
              <app-input
                type="date"
                v-model="inputs.due_date"
                :placeholder="$t('select_valid_date')"
                :required="true"
              />
              <!-- <app-input
                type="time"
                v-model="inputs.due_time"
              /> -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label>{{ $t("priority") }}</label>
              <app-input
                type="radio"
                :list="list"
                v-model="inputs.priority"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>

</div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
// import {CERTIFICATE_CATEGORY_GET} from "../../../../../app/Config/ApiUrl";
import { axiosGet } from "../../../../../../app/Helpers/AxiosHelper";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    id: Number,
    name: String,
    role: String,
  },
  data() {
    return {
      refreshShow: false,
      forms: [],
      addurl:actions.SUPPLIER_SHORTLIST_TASK_STORE,
      preloader: false,
      inputs: {
        supplier_id: this.id,
        start_date: new Date(),
        due_date: new Date(),
        // start_time: new Date().toLocaleTimeString(),
        // due_time: new Date().toLocaleTimeString(),
      },
      
      supplierList: [
        {
          id: this.id,
          value: this.name,
        }
      ],
      list: [
        {
          id: "High",
          value: "High",
        },
        {
          id: "Medium",
          value: "Medium",
        },
        {
          id: "Low",
          value: "Low",
        },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    }
  },
  // created() {
  //   if (this.selectedUrl) {
  //     this.modalTitle = this.$t("edit");
  //     this.postUrl = actions.CERTIFICATE_UPDATE;
  //     // this.preloader = true;
  //   }
  // },
  methods: {
    submit() {
      if (this.inputs.start_date)
        this.inputs.start_date = this.getDateFormatForBackend(
          this.inputs.start_date
        );
      if (this.inputs.due_date)
        this.inputs.due_date = this.getDateFormatForBackend(
          this.inputs.due_date
        );
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
     getForms() {
      axiosGet(actions.BUYER_CERTIFICATE_FORMS)
        .then((res) => {
        this.forms = res.data;
        })
        .catch((error) => {
          
        });
      },
      refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/mydocument', '_blank');
    },

    // getCategories() {
    //   axiosGet(actions.CERTIFICATE_CATEGORY_GET)
    //     .then((res) => {
    //       this.categorylist = res.data;
    //     })
    //     .catch((error) => { 
    //       
    //     });
    // },
  },

  mounted() {
        this.getForms();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    // this.getCategories();
  },
};
</script>
